


import apiClient from "./apiClient";
import { AuthResponse } from "../types/auth";

export async function login(email: string, password: string) {
  const { data } = await apiClient.post<AuthResponse>("/login", { email, password });
  return data;
}

export async function setPassword(password: string, token?: string) {
  const { data } = await apiClient.post(
    "/set_password",
    { password },
    token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : undefined
  );
  return data as { message: string };
}

export async function forgotPassword(email: string) {
  const { data } = await apiClient.post("/forgot_password", { email });
  return data as { message: string };
}

